import * as React from "react";
import type { Thread } from "../types/collaborateThread";
import { useCollaborateStore } from "../store/useCollaborateStore";
import { threadHasDocumentLocation } from "../utils/resolveThreadAnchor";
import { isAnchorSupported } from "../utils/jumpToThreadAnchor";
import { IconLocate } from "./icons";
import CollabSpinner from "./ui/CollabSpinner";

export type JumpToAnchorButtonProps = {
  thread: Thread;
  currentVersionId: string | null;
  className?: string;
};

const JumpToAnchorButton: React.FC<JumpToAnchorButtonProps> = ({
  thread,
  currentVersionId,
  className,
}) => {
  const [jumping, setJumping] = React.useState(false);
  const locateThreadInDocument = useCollaborateStore((s) => s.locateThreadInDocument);

  if (!threadHasDocumentLocation(thread) || !isAnchorSupported()) {
    return null;
  }

  return (
    <button
      type="button"
      className={className ?? "collab-locate-btn"}
      aria-label="Locate in document"
      title="Locate in document"
      disabled={jumping}
      onClick={(event) => {
        event.stopPropagation();
        setJumping(true);
        void locateThreadInDocument(thread.id, currentVersionId ?? "").finally(() => {
          setJumping(false);
        });
      }}
    >
      {jumping ? <CollabSpinner size="sm" label="Locating" /> : <IconLocate size={14} />}
    </button>
  );
};

export default JumpToAnchorButton;
